import { Table } from '@/ui';
import styled from 'styled-components';

export const StyledWebsitesContainerInner = styled.div`
  padding: 32px;
`;

export const StyledTable = styled(Table)`
  tbody .ant-table-cell {
    cursor: pointer;
  }
` as typeof Table;
